import { authenticationService } from './authentication';
import { LogManager } from '../utils/LogManager';
import { EventManager } from './EventManager';
import { HTTP_STATUS_PAYMENT_NEEDED } from '../utils/constants';
import { WebportalEvent } from './WebportalEvent';

const logManager = new LogManager('errorHandler');

function handleAuthenticationError(error: any) {
    logManager.log(error.message);
    authenticationService.getErrorHandler()();
}

function handleGenericError(error: any) {
    logManager.error(error);

    // Logout if user is not authenticated.
    authenticationService.isAuthenticated().then((isAuthenticated: boolean) => {
        if (!isAuthenticated) { authenticationService.signOut(); }
    });

    if (!error) { return; }

    if (error.name && error.name === 'NotAuthorizedException') {
        authenticationService.signOut();
    }

    if (error.response) {
        const response = error.response;
        const isLocalGatewayError =
            response.statusCode === 500 &&
            response.body &&
            typeof response.body === 'string' &&
            response.body.indexOf('Could not proxy request');
        const isPublicGatewayError =
            response.statusCode >= 502 && response.statusCode <= 504;
        if (isLocalGatewayError || isPublicGatewayError) {
            EventManager.fireCustomEvent(
                WebportalEvent.GatewayProblem,
                response.url
            );
        }
    }

    if (error.response && error.response.statusCode === HTTP_STATUS_PAYMENT_NEEDED) {
        EventManager.fireCustomEvent(WebportalEvent.UserSuspended);
    }

}

export function errorHandler(error: any) {
    if (error.isAuthenticationError) {
        handleAuthenticationError(error);
    } else {
        handleGenericError(error);
    }
}



// WEBPACK FOOTER //
// ./src/webportal/services/errorHandler.ts